import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchCalendarInbox, type CalendarInboxData } from '../api/calendar.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { Id } from '@/shared/types/domain';

/**
 * A caixa de entrada do calendário (spec-calendar-ux.md §5.1, decisão 95).
 *
 * **Consulta própria, e não um recorte da grade.** A da grade é chaveada pelo
 * mês visível; esta não tem intervalo nenhum, porque o projeto que espera você
 * quase nunca está no mês que você está olhando — uma pendência de novembro tem
 * de aparecer com a grade em agosto.
 *
 * A chave mora sob o prefixo `['calendar']`, então `invalidateAfterTransition`
 * já a alcança: reenviar um projeto o tira da caixa sem uma linha a mais lá.
 */
export function useCalendarInbox(
  profileId: Id | null,
  isReviewer: boolean,
): UseQueryResult<CalendarInboxData> {
  return useQuery({
    // Sem pessoa logada não há caixa — e não há tela, porque `/calendario` vive
    // sob `RequireAuth`. A chave usa `''` no instante entre o primeiro render e
    // a chegada de `useCurrentUser`; `enabled` impede que ela seja consultada.
    queryKey: queryKeys.calendarInbox(profileId ?? ''),
    queryFn: () => fetchCalendarInbox(profileId as Id, isReviewer),
    enabled: profileId !== null,
    staleTime: 30_000,
  });
}
